export default "__VITE_ASSET__e76b2258__"